import { AnimatePresence, motion } from 'framer-motion';
import { Typography } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import PropTypes from 'prop-types';

export const FieldError = ({ message }) => {
  return (
    <AnimatePresence
      mode="wait"
      initial={false}
    >
      <motion.div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '8px',
        }}
        {...framerError}
      >
        <ErrorOutlineOutlinedIcon
          fontSize="small"
          color="error"
          sx={{ fontSize: '1.1rem' }}
        />
        <Typography
          variant="caption"
          component="p"
          color="error"
          sx={{ px: 1 }}
        >
          {message}
        </Typography>
      </motion.div>
    </AnimatePresence>
  );
};

const framerError = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 },
  transition: { duration: 0.2 },
};

FieldError.propTypes = {
  message: PropTypes.string.isRequired,
};
